import {
  ADD_ARTICLE_COMMENT_SUCCESS,
  FETCH_ARTICLE_COMMENTS_SUCCESS,
  RESET_ARTICLE_COMMENTS,
  UPDATE_ARTICLE_COMMENTS_SUCCESS,
  REMOVE_ARTICLE_COMMENT_SUCCESS,
} from 'config/constants';

export default (state = [], action) => {
  const { type, comments, comment } = action;
  switch (type) {
    case FETCH_ARTICLE_COMMENTS_SUCCESS:
      return comments;
    case ADD_ARTICLE_COMMENT_SUCCESS:
      return [...state, comment];
    case UPDATE_ARTICLE_COMMENTS_SUCCESS:
      const newMap = state.map(item => {
        if (item.id !== comment.comment.id) return item;

        item.like_count = comment.comment.like_count;
        item.dislike_count = comment.comment.dislike_count;
        return item;
      });
      console.warn({ newMap });
      return newMap;
    case RESET_ARTICLE_COMMENTS:
      return [];
    case REMOVE_ARTICLE_COMMENT_SUCCESS:
      const newList = state.filter(c => c.id !== comment);

      return newList;
    default:
      return state;
  }
};
